// TODO: replace string literals with variables - (phyoh)
import { getZrmListingInfo, getZrmUserInfo } from '@zg-rentals/clickstream';
import { trackEvent } from '../../../client/analytics';

import type { ZrmClickstreamListing, ZrmClickstreamUser } from '@zg-rentals/clickstream';

const EVENT_IDS = {
  OPEN: '2288',
  CREATE_LISTING: '2289',
  CONFIRM_CREATE_LISTING: '2290',
  GO_BACK_AND_EDIT_ADDRESS: '2291',
  SEE_ALL_ACTIONS: '2292',
  CONFIRM_SEE_ALL_ACTIONS: '2293',
  ADD_FEED_CLICK: '7652',
  ADD_PROPERTY_CLICK: '7651',
} as const;

// https://dataportal.zillowgroup.net/event-registry/7652
const AddFeedClick = ({ user }: { user: ZrmClickstreamUser }) =>
  trackEvent.user({
    envelope: {
      event_template_id: '167',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.ADD_FEED_CLICK,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'properties',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'zrm_properties_page',
      trigger_source_nm: 'add_feed_link',
    },
    semantic: {
      semantic_event_nm: 'open_add_feed_modal',
      topic_tag_txt: ['zrm_properties'],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/7651
const AddPropertyClick = ({ user }: { user: ZrmClickstreamUser }) =>
  trackEvent.user({
    envelope: {
      event_template_id: '167',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.ADD_PROPERTY_CLICK,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'properties',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'zrm_properties_page',
      trigger_source_nm: 'add_property_link',
    },
    semantic: {
      semantic_event_nm: 'open_add_property_modal',
      topic_tag_txt: ['zrm_properties'],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/2288
const Open = ({ user, triggerObject }: { user: ZrmClickstreamUser; triggerObject?: string }) =>
  trackEvent.user({
    envelope: {
      event_template_id: '167',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.OPEN,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'properties',
      trigger_type_nm: 'impression',
      trigger_object_nm: triggerObject || 'no_trigger_object',
      trigger_source_nm: 'add_property_modal',
    },
    semantic: {
      semantic_event_nm: 'view_content',
      topic_tag_txt: ['zrm_properties'],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/2289
const CreateListing = ({ user }: { user: ZrmClickstreamUser | null }) =>
  trackEvent.user({
    envelope: {
      event_template_id: '167',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.CREATE_LISTING,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'properties',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'add_property_modal',
      trigger_source_nm: 'create_listing',
    },
    semantic: {
      semantic_event_nm: 'add_address',
      topic_tag_txt: ['zrm_properties'],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/2290
const ConfirmCreateListing = ({
  currentProperty,
  user,
}: {
  currentProperty: ZrmClickstreamListing;
  user: ZrmClickstreamUser;
}) =>
  trackEvent.listingUser({
    envelope: {
      event_template_id: '168',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.CONFIRM_CREATE_LISTING,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'properties',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'confirm_address_modal',
      trigger_source_nm: 'confirm',
    },
    semantic: {
      semantic_event_nm: 'create_listing',
      topic_tag_txt: ['zrm_properties'],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/2291
const GoBackAndEditAddress = ({ user }: { user: ZrmClickstreamUser | null }) =>
  trackEvent.user({
    envelope: {
      event_template_id: '167',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.GO_BACK_AND_EDIT_ADDRESS,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'properties',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'confirm_address_modal',
      trigger_source_nm: 'edit_property_information',
    },
    semantic: {
      semantic_event_nm: 'edit_address',
      topic_tag_txt: ['zrm_properties'],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/2292
const SeeAllActions = ({ user }: { user: ZrmClickstreamUser | null }) =>
  trackEvent.user({
    envelope: {
      event_template_id: '167',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.SEE_ALL_ACTIONS,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'properties',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'add_property_modal',
      trigger_source_nm: 'see_all_available_actions',
    },
    semantic: {
      semantic_event_nm: 'add_address',
      topic_tag_txt: ['zrm_properties'],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/2293
const ConfirmSeeAllActions = ({
  currentProperty,
  user,
}: {
  currentProperty: ZrmClickstreamListing;
  user: ZrmClickstreamUser;
}) =>
  trackEvent.listingUser({
    envelope: {
      event_template_id: '168',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.CONFIRM_SEE_ALL_ACTIONS,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'properties',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'confirm_address_modal | intent selection',
      trigger_source_nm: 'confirm',
    },
    semantic: {
      semantic_event_nm: 'create_listing',
      topic_tag_txt: ['zrm_properties'],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

const AddPropertyModalCSEvents = {
  AddFeedClick,
  AddPropertyClick,
  ConfirmCreateListing,
  ConfirmSeeAllActions,
  CreateListing,
  GoBackAndEditAddress,
  Open,
  SeeAllActions,
};

// Clickstream visualizer data-eventid attributes
AddFeedClick.data_event_id = EVENT_IDS.ADD_FEED_CLICK;
AddPropertyClick.data_event_id = EVENT_IDS.ADD_PROPERTY_CLICK;
ConfirmCreateListing.data_event_id = EVENT_IDS.CONFIRM_CREATE_LISTING;
ConfirmSeeAllActions.data_event_id = EVENT_IDS.CONFIRM_SEE_ALL_ACTIONS;
CreateListing.data_event_id = EVENT_IDS.CREATE_LISTING;
GoBackAndEditAddress.data_event_id = EVENT_IDS.GO_BACK_AND_EDIT_ADDRESS;
Open.data_event_id = EVENT_IDS.OPEN;
SeeAllActions.data_event_id = EVENT_IDS.SEE_ALL_ACTIONS;

export default AddPropertyModalCSEvents;
